module.exports = __webpack_public_path__ + "aeroland-digital-store-image-01.jpg?641d4d7acca51e582b98905d6222450f";